import { render, staticRenderFns } from "./organization-policy-detail.vue?vue&type=template&id=1eefc858&scoped=true"
import script from "./organization-policy-detail.vue?vue&type=script&lang=js"
export * from "./organization-policy-detail.vue?vue&type=script&lang=js"
import style0 from "./organization-policy-detail.vue?vue&type=style&index=0&id=1eefc858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eefc858",
  null
  
)

export default component.exports